export default "__VITE_ASSET__RPg4qzsr__"